import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Button, Checkbox, TextField, Grid } from "@material-ui/core";
import { Formik } from "formik";
import moment from "moment";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto"
  },
  table: {
    minWidth: 450
  },
  button: {
    margin: 10
  }
}));

function createData(idDay, day, startTime, endTime) {
  return { idDay, day, startTime, endTime };
}

const rows = [
  createData(1, "Monday", "07:30", "19:30"),
  createData(2, "Tuesday", "07:30", "19:30"),
  createData(3, "Wednesday", "07:30", "19:30"),
  createData(4, "Thursday", "07:30", "19:30"),
  createData(5, "Friday", "07:30", "19:30"),
  createData(6, "Saturday", "07:30", "19:30"),
  createData(7, "Sunday", "07:30", "19:30")
];

export default function ParkingWeek({ week, onCancel }) {
  const classes = useStyles();
  const [selected, setSelected] = React.useState([]);
  const isSelected = day => selected.indexOf(day) !== -1;
  const defaultValues = rows.map(row => {
    const obj = {};
    obj["startTime" + row.day] = row.startTime;
    obj["endTime" + row.day] = row.endTime;
    return obj;
  });

  let initialValues = {};
  for (let i = 0; i < defaultValues.length; i++) {
    Object.keys(defaultValues[i]).forEach(key => {
      initialValues[key] = defaultValues[i][key];
    });
  }

  const handleClick = name => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const hasSelectedWeek = week !== null;

  return (
    <Formik
      initialValues={initialValues}
      validate={values => {
        let errors = {};
        for (let i = 0; i < rows.length; i++) {
          if (
            !moment(values[`startTime${rows[i].day}`], "HH:mm").isBefore(
              moment(values[`endTime${rows[i].day}`], "HH:mm")
            )
          ) {
            errors[`endTime${rows[i].day}`] = "end time > start time";
          }
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          alert(JSON.stringify(values, null, 2));
          setSubmitting(false);
        }, 400);
      }}
    >
      {({ errors, handleChange, handleSubmit, values }) => (
        <form onSubmit={handleSubmit}>
          <Paper className={classes.root}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Day</TableCell>
                  <TableCell align="center">Start Hour</TableCell>
                  <TableCell align="center">End Hour</TableCell>
                  <TableCell align="center">24 hours</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(row => {
                  const isItemSelected = isSelected(row.day);
                  const labelId = `enhanced-table-checkbox-${row.day}`;
                  return (
                    <TableRow key={row.day}>
                      <TableCell component="th" scope="row">
                        {`${row.day} ${
                          week !== null
                            ? week
                                .isoWeekday(1)
                                .day(row.idDay)
                                .format("DD")
                            : ""
                        }`}
                      </TableCell>
                      <TableCell align="center">
                        <TextField
                          id={`startTime${row.day}`}
                          type="time"
                          variant="outlined"
                          margin="dense"
                          value={values[`startTime${row.day}`]}
                          InputLabelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            step: 600 // 10 min
                          }}
                          onChange={handleChange}
                          disabled={!hasSelectedWeek || isItemSelected}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <TextField
                          id={`endTime${row.day}`}
                          type="time"
                          variant="outlined"
                          margin="dense"
                          value={values[`endTime${row.day}`]}
                          InputLabelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            step: 600 // 10 min
                          }}
                          onChange={handleChange}
                          disabled={!hasSelectedWeek || isItemSelected}
                          helperText={errors && errors[`endTime${row.day}`]}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          onChange={() => handleClick(row.day)}
                          checked={isItemSelected}
                          inputProps={{ "aria-labelledby": labelId }}
                          disabled={!hasSelectedWeek}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <Grid container justify="flex-end">
              <Grid item>
                <Button
                  onClick={() => {
                    onCancel("showForm");
                    onCancel("showConfigParkingForm");
                  }}
                  variant="contained"
                  color="secondary"
                  size="large"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.button}
                  disabled={!hasSelectedWeek}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </form>
      )}
    </Formik>
  );
}
